export default __webpack_public_path__ + "static/media/statusPositive.251b41ad.svg";